/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Skeleton } from 'primereact/skeleton';
import React from 'react';

export const TimeLineSkeleton: React.FC = () => {
  return (
    <div className="flex flex-column gap-3 w-full">
      {[1, 2, 3].map((i) => (
        <div key={i} className="flex flex-row gap-4 items-center justify-content-between">
          <Skeleton className="h-3rem w-18rem" />
          <div className="flex flex-column gap-3  w-full">
            <Skeleton className="h-1rem w-full" />
            <Skeleton className="h-1rem w-full" />
          </div>
        </div>
      ))}
    </div>
  );
};
